// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import { connect } from 'react-redux';

import TrackActions from 'app/track/TrackActions';

export const TrackOnMount = createReactClass({
  displayName: 'TrackOnMount',

  propTypes: {
    shouldTrack: PropTypes.bool.isRequired,
    trackingEventName: PropTypes.string.isRequired,
    trackingEventData: PropTypes.object.isRequired,
    onTrack: PropTypes.func.isRequired,
    children: PropTypes.any,
  },

  UNSAFE_componentWillMount() {
    const { props } = this;
    if (props.shouldTrack) {
      props.onTrack(props.trackingEventName, props.trackingEventData);
    }
  },

  render() {
    return this.props.children;
  },
});

export const trackOnMount = (
  trackingEventName,
  computeTrackingEventData,
  shouldTrack = () => true
) => Component => props => (
  <TrackOnMount
    shouldTrack={shouldTrack(props)}
    trackingEventData={computeTrackingEventData(props)}
    trackingEventName={trackingEventName}
    {...props}
  >
    <Component {...props} />
  </TrackOnMount>
);

const mapDispatchToProps = dispatch => ({
  onTrack(...args) {
    dispatch(TrackActions.track(...args));
  },
});

export const connectedTrackOnMount = (...args) => Component => {
  const TrackedComponent = trackOnMount(...args)(Component);
  return connect(
    null,
    mapDispatchToProps
  )(TrackedComponent);
};
